import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	ITest,
	LabelPosition,
	SinNumberRHF,
} from "@websential/cosmic-v20";
import { FC, useEffect } from "react";

interface IReimbursementsInfoFieldsPanel extends ITest {
	accountSettingsDDL:any;
}

export const ReimbursementsInfoFieldsPanel: FC<IReimbursementsInfoFieldsPanel> = ({
	accountSettingsDDL
}) => {

	
	return (
		<>
			<EnhancedDropDownRHFWithLabel
				label="Reimbursement"
				selectName="reimbursement"
				testId="reimbursement"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>
		</>
	);
};
